import { createFileRoute } from '@tanstack/react-router';
import { ProductsPage } from '@/features/admin/Products';

export const Route = createFileRoute('/_app/products')({ component: ProductsPage });
